export default "__VITE_ASSET__DkgX5KHC__"